import React from 'react'
import Banners from '../../Components/Banners/Banners'
import Products from '../../Components/Products/Products'
import '../../css/Components/Demo/Demo.css';
import Footer from '../../Pages/Footer/Footer'
import BtnWhatsapp from '../../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../Components/Cart/Cart'
//import NavbarMobile from '../../Components/NavbarMobile/NavBarMobile'
import NavbarMobile from '../../Components/NavBarMobile/NavBarMobile'
import ProductsMore from '../../Components/ProductsMore/ProductsMore'
import { useMediaQuery } from '@react-hook/media-query';
export default function Demo({ info }) {
    const isScreenLarge = useMediaQuery('(min-width: 900px)');
    return (
        <section className='demo'>
            <Banners />
            <ProductsMore />
            <Products />

            <Footer info={info} />
            <NavbarMobile />

            {isScreenLarge &&
                <>
                    <Cart />
                    <BtnWhatsapp />
                </>
            }
        </section>
    )
}
